/** Spec Intelligence brand gradient — purple-to-blue, used on AI action buttons. */
export const SPEC_INT_GRADIENT = 'linear-gradient(135deg, #5B2D8E 0%, #1565C0 100%)'

/** Darkened hover variant of {@link SPEC_INT_GRADIENT}. */
export const SPEC_INT_GRADIENT_HOVER = 'linear-gradient(135deg, #4a2275 0%, #0d47a1 100%)'

/** Accent color for AI-generated content (AI Recs tile, AI badge). */
export const SPEC_INT_AI_COLOR = '#6A0DAD'

/** Display label for the Cross-References finding category. */
export const CROSS_REFERENCES_LABEL = 'Cross-References'

/** Display label for the ErrorsAndOmissions finding category. */
export const OMISSION_LABEL = 'Errors & Omissions'

/** Display label for the Contradictions finding category. */
export const CONTRADICTION_LABEL = 'Contradictory Language'
